import { Splide } from '@splidejs/splide';
import '@splidejs/splide/css/core';

class MemberSlides {
  constructor(el) {
    this.dom = {el: el};
    this.dom.slider = {
      main: this.dom.el.querySelector('[data-js="member-slide-main"] .splide'),
      thumbnail: this.dom.el.querySelector('[data-js="member-slide-thumbnail"] .splide')
    }

    this.dom.thumbnail = null;

    this.dom.container = this.dom.slider.thumbnail.querySelector('.splide__list');
    this.dom.slides = this.dom.slider.thumbnail.querySelectorAll('.splide__slide');
    // this.dom.slidesの最初の要素取得
    const shifted = this.dom.slides[0];
    // 取得した要素を最後に移動
    this.dom.container.append(shifted);
    

    this.dom.page = this.dom.el.querySelector('.splide-page')
    this.dom.current = this.dom.el.querySelector('.splide-page__current')
    this.dom.total = this.dom.el.querySelector('.splide-page__total')

    this.mql = window.matchMedia('screen and (min-width: 768px)');
    this.checkBreakPoint = this.checkBreakPoint.bind(this);

    this.mainContoller = this.mainContoller.bind(this);

    this.main = {
      slider: null,
      total: null,
      rate: null,
    }

    this.thumbnail = {
      slider: null,
      total: null,
      rate: null,
    }
    
    this.option = {
      sp: {
        autoWidth: true,
        speed: 900,
        arrows: true,
        pagination: false,
      },
      pc: {
        type: 'fade',
        speed: 900,
        rewind: true,
        arrows: true,
        pagination: false,
      },
      thumbnail: {
        type: 'loop',
        rewind: true,
        autoWidth: true,
        speed: 900,
        arrows: false,
        pagination: false,
        snap: true,
        perMove: 1,
        flickMaxPages: 1,
        drag: true,
        // start: 1,
        // isNavigation: true,
      }
    };

    this.init();
  }

  init() {
    const _this = this;

    // ブレイクポイントの瞬間に発火
    this.mql.addListener(this.checkBreakPoint);
    // 初回チェック
    this.checkBreakPoint(this.mql);
  }

  setPage() {
    this.dom.current.textContent = this.main.rate * this.main.total;
    this.dom.total.textContent = `/ ${this.main.total}`;
  }
  
  // moveMainSlide() {
  //   const next = (this.main.rate * this.main.total - 1 === 0) ? this.main.total : this.main.rate * this.main.total - 1;
  //   const { Move } = this.main.slider.Components;
  //   Move.move(next, next, next - 1);
  // }
  
  // moveThumbnailSlide() {
  //   const next = this.main.rate * this.main.total;
  //   const { Move } = this.thumbnail.slider.Components;
  //   Move.move(next, next, next - 1);
  // }

  mainContoller(e) {
    console.log(e.currentTarget.dataset.index)
    const index = Number(e.currentTarget.dataset.index);
    console.log(typeof index)
    this.main.slider.go(index)
  }

  checkBreakPoint(_mql) {
		if (!_mql.matches) {
      // console.log('sp');

      if (this.main.slider) this.main.slider.destroy();

      this.main.slider = new Splide(this.dom.slider.main, this.option.sp);
      this.dom.progress = this.main.slider.root.querySelector('.splide-carousel-progress-bar');
      this.main.slider.on('mounted move', () => {
        this.main.total  = this.main.slider.Components.Controller.getEnd() + 1;
        this.main.rate = Math.min( ( this.main.slider.index + 1 ) / this.main.total, 1 );
        this.dom.progress.style.width = String( 100 * this.main.rate ) + '%';
        this.setPage();
      } );
      this.main.slider.mount();

      return;
    } else {
      // console.log('pc');

      if (this.main.slider) this.main.slider.destroy();

      this.main.slider = new Splide(this.dom.slider.main, this.option.pc);
      this.dom.progress = this.main.slider.root.querySelector('.splide-carousel-progress-bar');
      this.main.slider.on('mounted', () => {
        this.main.total = this.main.slider.Components.Controller.getEnd() + 1;
        this.main.rate = Math.min( ( this.main.slider.index + 1 ) / this.main.total, 1 );
        this.dom.progress.style.width = String( 100 * this.main.rate ) + '%';
        this.setPage();
      } );
      this.main.slider.on('move', () => {
        this.main.total = this.main.slider.Components.Controller.getEnd() + 1;
        this.main.rate = Math.min( ( this.main.slider.index + 1 ) / this.main.total, 1 );
        this.dom.progress.style.width = String( 100 * this.main.rate ) + '%';
        this.setPage();
        // this.moveThumbnailSlide();
      } );
      
      this.thumbnail.slider = new Splide(this.dom.slider.thumbnail, this.option.thumbnail);
      this.thumbnail.slider.on('mounted', () => {
        this.dom.thumbnail = this.dom.slider.thumbnail.querySelectorAll('[data-index]');
        [...this.dom.thumbnail].forEach(el => {
          el.addEventListener('click', this.mainContoller);
        })
      } );

      this.main.slider.sync(this.thumbnail.slider);
      this.thumbnail.slider.mount();
      this.main.slider.mount();

      return;
		}
	}
}

export default MemberSlides